"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../BaseComponent");
var SliderProduct = /** @class */ (function (_super) {
    __extends(SliderProduct, _super);
    function SliderProduct($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        return _this;
    }
    SliderProduct.prototype.bind = function () {
        // @ts-ignore
        this.$view.slick({
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button class="arrow-btn prev-arrow"></button>',
            nextArrow: '<button class="arrow-btn next-arrow"></button>',
            responsive: [
                {
                    breakpoint: 1370,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    };
    return SliderProduct;
}(BaseComponent_1.default));
exports.default = SliderProduct;
